import React from "react";
import styled from "styled-components";
import Link from "next/link";

import {
  PaperIcon,
  BookIcon,
  FreeFortuneIcon,
  CounselingIcon,
} from "public/media/icons";

export const MediaNav = () => {
  return (
    <div tw="flex border border-solid border-gray bg-white">
      <Link href="/press" prefetch={false} passHref>
        <NavList>
          <PaperIcon />
          <Label>恋愛コラム</Label>
        </NavList>
      </Link>
      <Link href="/miracle" prefetch={false} passHref>
        <NavList>
          <BookIcon />
          <Label>占いコラム</Label>
        </NavList>
      </Link>
      <Link href="/free_fortune" prefetch={false} passHref>
        <NavList>
          <FreeFortuneIcon />
          <OtherLabel>無料占い</OtherLabel>
        </NavList>
      </Link>
      <Link href="/" prefetch={false} passHref>
        <NavList>
          <CounselingIcon />
          <Label>占いメニュー</Label>
        </NavList>
      </Link>
    </div>
  );
};

const NavList = styled.a`
  border-left: 0.5px solid #dfe7f2;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-weight: 600;
  font-size: 9px;
  width: 25%;
  height: 68px;
  cursor: pointer;

  &:first-child {
    border: none;
  }
`;

const Label = styled.span`
  margin-top: 6px;
`;

const OtherLabel = styled.span`
  margin-top: 1px;
`;
